import { defineStore } from 'pinia';
import { fetchBuildingAlerts } from '@/api';
import { Alert_AlertStatus } from '@/generated/msh/resource/v1/alert_pb';

export default defineStore({
  id: 'alerts',

  state: () => ({
    alerts: [],
    activeAlerts: [],
    alertsMeta: {},
    activeAlertsMeta: {},
  }),

  getters: {},

  actions: {
    async loadAlerts(parentId, filter = {}) {
      const params = { parentId, ...filter };
      const { alerts, meta } = await fetchBuildingAlerts(params);

      this.alerts = alerts;
      this.alertsMeta = meta;
    },

    async loadActiveAlerts(parentId, filter = {}) {
      const params = {
        parentId,
        filter: { status: Alert_AlertStatus.WAITING_RESPONSE, ...filter },
      };
      const { alerts, meta } = await fetchBuildingAlerts(params);

      this.activeAlerts = alerts;
      this.activeAlertsMeta = meta;
    },

    async resolverAlert(id) {
      this.activeAlerts = [
        ...this.activeAlerts.filter((alert) => alert.alertId !== id),
      ];
    },
  },
});
